module.exports = __webpack_public_path__ + "Roboto-Light-webfont.816d43bc217485bc52e3.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.woff
// module chunks = 1